import React, { useState } from 'react';
import cityCoords from '../constants/city_coordinates.json';

export const EventMapContext = React.createContext();

export default function EventMapProvider({ children }) {
  // Dropdown Visible
  const [categoryVisible, setCategoryVisible] = useState(false);
  const [datesVisible, setDatesVisible] = useState(false);
  const [areaVisible, setAreaVisible] = useState(false);

  const [currentMenu, setCurrentMenu] = useState('');
  const [mapVisible, setMapVisible] = useState(true);
  const [sliderVisible, setSliderVisible] = useState(true);
  const [bounds, setBounds] = useState(null);
  const [shouldFitBounds, setShouldFitBounds] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [mapLoaded, setMapLoaded] = useState(false);

  // Events Variables
  const [areas, setAreas] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [categories, setCategories] = useState([]);
  const [titleContains, setTitleContains] = useState('');

  const [filterType, setFilterType] = useState();
  const [mapCenter, setMapCenter] = useState(cityCoords['full-destin']);

  const setDropdown = dropdown => {
    switch (dropdown) {
      case 'category':
        setDatesVisible(false);
        setAreaVisible(false);
        setCategoryVisible(true);
        break;

      case 'dates':
        setAreaVisible(false);
        setCategoryVisible(false);
        setDatesVisible(true);
        break;

      case 'area':
        setDatesVisible(false);
        setCategoryVisible(false);
        setAreaVisible(true);
        break;

      case null:
        setDatesVisible(false);
        setAreaVisible(false);
        setCategoryVisible(false);
        break;

      default:
        console.error(
          `%c No Dropdown case for ${dropdown} found!`,
          'font-size: 28px;'
        );
        break;
    }
  };

  return (
    <EventMapContext.Provider
      value={{
        mapVisible,
        sliderVisible,
        bounds,
        setMapVisible,
        setSliderVisible,
        setBounds,
        startDate,
        endDate,
        setStartDate,
        setEndDate,
        filterType,
        setFilterType,
        currentMenu,
        setCurrentMenu,
        currentPage,
        setCurrentPage,
        categoryVisible,
        setCategoryVisible,
        datesVisible,
        setDatesVisible,
        areaVisible,
        setAreaVisible,
        areas,
        setAreas,
        setDropdown,
        mapCenter,
        setMapCenter,
        categories,
        setCategories,
        titleContains,
        setTitleContains,
        shouldFitBounds,
        setShouldFitBounds,
        mapLoaded,
        setMapLoaded,
      }}
    >
      {children}
    </EventMapContext.Provider>
  );
}
